<template lang="pug">
  b-button.ml-2(
    @click="tableToExcel('tblList', memberId, tableName)"
    size="sm"
    variant="success"
  )
    i.fas.fa-file-excel.mr-2
    span {{ $t("ui.export_excel") }}
    a#dlink.d-none
</template>

<script>
export default {
  props: {
    memberId: {
      type: String,
      default: ""
    }
  },
  computed: {
    tableName() {
      return this.$route.path.split("/")[1];
    }
  },
  methods: {
    download_csv(csv, filename) {
      var csvFile;
      var downloadLink;
      // CSV FILE
      csvFile = new Blob([csv], {
        type: "text/csv"
      });
      // Download link
      downloadLink = document.createElement("a");
      // File name
      downloadLink.download = filename;
      // We have to create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);
      // Make sure that the link is not displayed
      downloadLink.style.display = "none";
      // Add the link to your DOM
      document.body.appendChild(downloadLink);
      // Lanzamos
      downloadLink.click();
    },
    export_table_to_csv(filename) {
      var csv = [];
      // var html = "";
      var rows = document.querySelectorAll("#tblList tr");
      for (var i = 0; i < rows.length; i++) {
        var row = [],
          cols = rows[i].querySelectorAll("td, th");
        for (var j = 0; j < cols.length; j++)
          row.push(cols[j].innerText.replace(",", ";"));
        csv.push(row);
      }
      // Download CSV
      this.download_csv(
        csv.join("\n"),
        filename + " " + this.$moment().format("YYYY-M-DD HH:mm:ss") + ".csv"
      );
    },
    tableToExcel(table, name, filename) {
      var uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
        base64 = function(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
            return c[p];
          });
        };
      if (!table.nodeType) table = document.getElementById(table);
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      document.getElementById("dlink").href = uri + base64(format(template, ctx));
      document.getElementById("dlink").download = filename + " " + this.$moment().format("YYYY-M-DD HH:mm:ss");
      document.getElementById("dlink").click();
    }
  }
};
</script>